<template>
    <v-form v-model="valid" fast-fail @submit.prevent="handleSubmit">
        <ObraSocialSelect @seleccionar-obraSocial="cambiarOS"></ObraSocialSelect>
        <v-text-field
            v-model="nombrePlan"
            :rules="obligatorioAlfabetico"
            label="Nombre del plan"
            required
            variant="solo"
        ></v-text-field>
        <v-btn
            type="submit"
            :disabled="!valid"
            id="boton-verde"
            :loading="cargando"
        >
            Agregar plan
        </v-btn>
    </v-form>
    <ClosableAlert
        v-if="alert"
        :type="alertType"
        :key="alertKey"
        :texto="mensaje"
        titulo="Agregar plan a obra social"
    ></ClosableAlert>
</template>
<style src="../assets/general.css"></style>
<script>
    import ObraSocialSelect from './ObraSocialSelect.vue';
    import ClosableAlert from './ClosableAlert.vue';
    import { obligatorioAlfabetico } from '../_helpers/rules';
    import AdminService from '../api/AdminService';

    const adminService = new AdminService();

    export default {
        components: {
            ObraSocialSelect,
            ClosableAlert
        },
        data() {
            return {
                valid: false,
                obraSocialId: null,
                nombrePlan: '',
                obligatorioAlfabetico: obligatorioAlfabetico,
                cargando: false,
                alert: false,
                alertType: '',
                mensaje: '',
                alertKey: 0
            }
        },
        methods: {
            async handleSubmit(){
                this.cargando = true;
                const response = await adminService.cargarPlanOS(this.obraSocialId, this.nombrePlan);
                if(response && response.status === 200){
                    if(response.data == false){
                        this.alertType = 'info';
                        this.mensaje = 'Ya existe un plan con ese nombre en la obra social seleccionada';
                    } else {
                        this.alertType = 'success';
                        this.mensaje = 'Plan agregado correctamente';
                    }
                } else{
                    this.alertType = 'info';
                    this.mensaje = 'Error al agregar plan';
                }
                this.alert = true;
                this.alertKey += 1;
                this.cargando = false;
            },
            cambiarOS(os){
                this.obraSocialId = os.id;
            }
        }
    }
</script>